<template>
    <div :id="id"></div>
</template>

<script setup>
    import { ref, defineProps, onMounted, watch, nextTick, computed } from "vue";
    import {useLocales} from "@/composables/locales";
    import i18n from "@/plugins/i18n";
    import {useStore} from "vuex";
    import ChangeDateModal from "@/Modules/CRM/components/Modals/Appointment/ChangeDateModal.vue";

    const store = useStore()
    const { locale } = useLocales()

    const emits = defineEmits(['handleClick', 'handleMonthClick, handleDateClick'])

    watch(() => locale.value, (value) => {
        nextTick(() => initFullCalendar() )
    }, { deep: true })

    const props = defineProps({
        id: String,
        event: {
            type: Array,
            default: []
        },
        availableViews: {
            type: Array,
            default: () => ['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listMonth']
        },
        size: {
            type: Object,
            default: {}
        },
        headerToolbar: {
            type: Boolean,
            default: true
        }
    });

    var calendar

    const fullcalendarValue = ref(null)
    const initialView = computed(() => props.availableViews[0])
    const events = computed(() => props.event)
    const currentUser = computed(() => store.getters['user/currentUser'])
    const selectedDates = ref([]);

    watch(() => events.value, (newValue) => {
        if (!calendar) return;

        calendar.getEvents().forEach(event => {
            event.remove();
        });

        if (newValue) {
            newValue.forEach(event => {
                calendar.addEvent(event);
            });
        }
    });

    watch(selectedDates.value, () => {
        if (calendar) {
            calendar.render();
        }
    }, { deep: true });

    onMounted(() => {
        nextTick(() => {
            initFullCalendar();
        });
    });

  
    function initFullCalendar() {
        if (calendar) {
            calendar.destroy(); 
        }

        var todayDate = moment().startOf('day');
        var TODAY = todayDate.format('YYYY-MM-DD');

        var calendarEl = document.getElementById(props.id);
        
        if (!calendarEl) {
            console.error("Élément non trouvé pour FullCalendar !");
            return;
        }

        calendar = new FullCalendar.Calendar(calendarEl, {
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: props.availableViews.join(',')
            },
            height: props.size.height || '900px',
            contentHeight: props.size.contentHeight || '850px',
            aspectRatio: 3,
            eventOverlap: false,
            nowIndicator: true,
            eventMinHeight: 120,
            now: TODAY + 'T09:25:00',
            initialView: initialView.value,
            initialDate: TODAY,
            editable: true,
            locale: locale.value,
            dayMaxEvents: 2,
            navLinks: true,
            events: events.value,
            datesSet: function (info) {
                const { currentStart, currentEnd } = info.view;
                emits('handleMonthClick', moment(currentStart).format('DD-MM-YYYY'), moment(currentEnd).format('DD-MM-YYYY'));
            },
            dateClick: function(info) {
                const clickedDate = info.dateStr;

                const index = selectedDates.value.indexOf(clickedDate);
                if (index === -1) {
                    selectedDates.value.push(clickedDate);
                } else {
                    selectedDates.value.splice(index, 1);
                }
                emits('handleDateClick', clickedDate);
                calendar.render();
            },
            eventClick: handleEventClick,
            dayCellDidMount: handleDayCellDidMount,
            eventDidMount: function (info) {
                const { color } = info.event.extendedProps;
                info.el.style.backgroundColor = color || '#0072CE0D';
                info.el.style.borderColor = color || '#0072CE0D';
            },
        });

        calendar.render();
    }

    function handleEventClick(info){
        emits('handleClick', info.event.extendedProps.id)
    }

    function handleDayCellDidMount(arg){
        const today = new Date();
        const dateStr = moment(arg.date).format('YYYY-MM-DD');

        const isToday =
            arg.date.getDate() === today.getDate() &&
            arg.date.getMonth() === today.getMonth() &&
            arg.date.getFullYear() === today.getFullYear();

        const isSelected = selectedDates.value.includes(dateStr);

        if (isToday) {
            arg.el.style.backgroundColor = '#0072CE33';
        }

        if (isSelected) {
            arg.el.style.backgroundColor = '#0072CE';
            arg.el.style.color = 'white';
        }
    }
</script>

<style scoped>
    .bg_class{
        accent-color: var(--bs-primary);
    }
    .fc-v-event {
        border: none !important;
        border: none !important;
        background-color: transparent !important;
        background-color: var(--fc-event-bg-color, transparent);
    }
</style>